import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { CSSProperties, ReactNode } from "react";

import { useCircleV4 } from "@/react/hooks/useCircleV4";

import { useNotificationContext } from "../NotificationContext";

export interface ListWrapperProps {
  children: ReactNode;
  className?: string;
  isFullPage?: boolean;
  style?: CSSProperties;
}

export const ListWrapper = ({
  children,
  className,
  style,
  isFullPage = false,
}: ListWrapperProps) => {
  const { currentCommunitySettings } = usePunditUserContext();
  const isNotificationsTabV2Enabled = Boolean(
    currentCommunitySettings?.live_pulse_notifications_tab_v2_enabled,
  );
  const { isBannerDismissed } = useNotificationContext();
  const isBannerVisible = isNotificationsTabV2Enabled && !isBannerDismissed;
  const { isCircleV4 } = useCircleV4();

  if (isCircleV4) {
    return (
      <div
        className={classNames(
          "flex w-full flex-col justify-between space-y-px",
          {
            "min-h-0 flex-1 overflow-y-auto [scrollbar-gutter:stable] p-2":
              !isFullPage,
          },
          className,
        )}
        style={style}
        id="user-notifications-panel-header"
      >
        {children}
      </div>
    );
  }

  return (
    <div
      className={classNames(
        "flex w-full flex-col justify-between space-y-px overflow-y-auto [scrollbar-gutter:stable]",
        {
          "h-[calc(100dvh-95px)] p-2 lg:h-[calc(100%-100px)]":
            !isFullPage && !isBannerVisible, // 100px = header (44px) + tabs (44px) + margin (12px)
          "h-[calc(100dvh-95px)] p-2 lg:h-[calc(100%-170px)]":
            !isFullPage && isBannerVisible, // 170px = 100px + banner (52px min-height + padding)
        },
        className,
      )}
      style={style}
      id={
        isFullPage
          ? "user-notifications-full-page-header"
          : "user-notifications-panel-header"
      }
    >
      {children}
    </div>
  );
};
